import { render, staticRenderFns } from "./annexlist.vue?vue&type=template&id=018be94d&scoped=true&"
import script from "./annexlist.vue?vue&type=script&lang=js&"
export * from "./annexlist.vue?vue&type=script&lang=js&"
import style0 from "./annexlist.vue?vue&type=style&index=0&id=018be94d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018be94d",
  null
  
)

export default component.exports